<template>
    <v-card @click.prevent="$emit('clickcard')" class="ma-1 mt-2 pa-0" :style="{backgroundColor: selectedAppointment != null && appointment.id == selectedAppointment.id ? '#f2fcff' : 'white'}">
        <v-card-text style="padding: 0px;">            
            <div style="font-size: 0.9em; font-weight: bold; text-wrap: nowrap; overflow: hidden;"
                class="d-flex- justify-space-between- align-center- flex-wrap- mb-2"
            >
            <div style="min-height: 30px; align-items: center; display: flex;" class="appt-card" :class="{focused: focused, selected: selected, isroute: isroute}">                
                <v-tooltip bottom v-if="appointment.ing_locked_reason.includes('ΠΡΟΗΓΟΥΜΕΝΟ BATCH')">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" style="margin-left: 5px;" small>mdi-arrow-u-right-bottom</v-icon>
                    </template>
                    <v-chip x-small class="ml-1" style="background-color: white;" v-for="c in appointment.ing_locked_reason" :key="c">{{ c }}</v-chip>
                </v-tooltip>
                <v-tooltip bottom v-if="appointment.ing_locked_reason.includes('ΤΕΧΝΙΚΟΣ') || appointment.ing_locked_reason.includes('ΤΕΧΝΙΚΟΣ & ΧΡΟΝΟΣ')">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" style="margin-left: 5px;" small>mdi-lock</v-icon>
                    </template>
                    <v-chip x-small class="ml-1" style="background-color: white;" v-for="c in appointment.ing_locked_reason" :key="c">{{ c }}</v-chip>
                </v-tooltip>                
                <span style="font-size: 0.9em; color: black; margin-left: 10px;">{{ appointment.customer_name }}</span>
            </div>   
            <!--<div  v-else style="min-height: 30px; align-items: center; display: flex;" class="appt-card" :class="{focused: focused, selected: selected, isroute: isroute}">                           
                <span style="font-size: 0.9em; color: black;">{{ appointment.customer_name }}</span>
            </div>-->         
            <!--<v-checkbox
                dense
                light
                color="white"                
                style="font-size: 0.8em; padding-bottom: 2px; padding-left: 4px;"
                v-model="selected"     
                class="mt-0 mb-0 pb-0 appt-card"    
                :class="{focused: focused, selected: selected, isroute: isroute}"
                hide-details
                @click.stop=""
                @change="selectedchanged({id: appointment.id, selected})"
            >            
            <template v-slot:label>
                <span style="font-size: 0.7em">{{ appointment.customer_name }}</span>
            </template>
            </v-checkbox>-->            
            <p style="font-size: 0.9em; font-weight: bold; text-wrap: wrap; overflow: hidden; max-height: 60px; margin-bottom: 2px; margin-top: 4px; padding-left: 6px; padding-right: 4px; word-break: break-all;">                                
                {{ appointment.loc_city }} - {{ appointment.loc_address }}                            
            </p>     
            <p class="d-flex mb-2">
                <span @click="edit" v-if="isroute" class="slotbutton ml-2">                                
                    <v-icon v-if="appointment.assignment && appointment.assignment.prelocked_tech && appointment.assignment.prelocked_time == true" style="margin-left: 2px; margin-right: 8px; color: white;" small>mdi-lock</v-icon>{{ appointment.assignment.appoint_timeslot || '--:--' }}    
                </span>
                <v-tooltip bottom v-if="appointment.ing_cancel">                    
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="#ff5d5d" class="ml-2">mdi-cancel</v-icon>
                    </template>
                    <span v-for="r in appointment.ing_cancel_reason" :key="r">{{ r }}</span>
                </v-tooltip>
                <v-tooltip bottom v-if="appointment.ing_excluded || (selectedTechnician && selectedTechnician.excluded)">                    
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="#ff5d5d" class="ml-2">mdi-eject-circle-outline</v-icon>
                    </template>
                    <span>Εξαιρείται από την Αυτόματη Ανάθεση</span>
                </v-tooltip>    
                <v-tooltip bottom v-if="appointment.appt_category.find(c=>c.startsWith('ΦΟΡΤΙΟ ΕΚΤΟΣ ΟΡΙΩΝ'))">                    
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="red" class="ml-2">mdi-alert</v-icon>
                    </template>
                    <span>{{ appointment.appt_category.find(c=>c.startsWith('ΦΟΡΤΙΟ ΕΚΤΟΣ ΟΡΙΩΝ')) }}</span>
                </v-tooltip>                 
                <v-tooltip bottom v-if="appointment.appt_category.find(c=>c.startsWith('ΠΡΟΤΕΡΑΙΟΤΗΤΑ'))">                    
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="#3878c7" class="ml-2">mdi-podium-gold</v-icon>
                    </template>
                    <span>{{ appointment.appt_category.find(c=>c.startsWith('ΠΡΟΤΕΡΑΙΟΤΗΤΑ')) }}</span>
                </v-tooltip> 
                <v-tooltip bottom v-if="appointment.appt_category.find(c=>c.startsWith('ΠΑΡΑΔΟΣΗ ΕΓΚΑΤΑΣΤΑΣΗ'))">                    
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" color="#428fed" class="ml-2">mdi-truck-delivery</v-icon>
                    </template>
                    <span>{{ appointment.appt_category.find(c=>c.startsWith('ΠΑΡΑΔΟΣΗ ΕΓΚΑΤΑΣΤΑΣΗ')) }}</span>
                </v-tooltip> 
            </p>                                                       
            </div>                        
        </v-card-text>
        <v-card-actions style="justify-content: space-evenly; padding-top: 0px;">
            <!--<v-btn x-small icon>
            <v-icon>mdi-share-variant</v-icon>
            34-34
            </v-btn>-->
            
            <div class="btnvertical">
                <v-icon small>mdi-wrench</v-icon>            
                <span>{{ appointment.work_items.length }}</span>
            </div>

            <div class="btnvertical">
                <v-icon small>mdi-timer-sand</v-icon>            
                <span>{{ appointment.work_items.map(x=>x.estimated_duration_mins).reduce((partialSum, a) => partialSum + a, 0) }}m</span>
            </div>

            <!--<div class="btnvertical" v-if="isroute">
                <v-icon small>mdi-car-lifted-pickup</v-icon>            
                <span>{{ appointment.assignment.transfer_time_mins }}m </span>
            </div>-->

            <div class="btnvertical" v-if="isroute">
                <v-icon small>mdi-information</v-icon>            
                <span>{{ appointment.assignment.transfer_time_mins }}-{{ appointment.assignment.estimated_arrival_time ? appointment.assignment.estimated_arrival_time.substring(0,5).replace(':', '') : '-' }}</span>
               <!-- <span>{{ appointment.assignment.estimated_arrival_time }}</span>-->
            </div>
            
        </v-card-actions>
    </v-card>
</template>
<script>
const markerss = {
    normal: require("src/assets/images/marker_normal.svg"),
    normal_focused: require("src/assets/images/marker_normal_focused.svg"),
    selected: require("src/assets/images/marker_selected.svg"),
    selected_focused: require("src/assets/images/marker_selected_focused.svg"),
    route: require("src/assets/images/marker_route.svg"),
    route_focused: require("src/assets/images/marker_route_focused.svg"),
    start: require("src/assets/images/marker_start.svg"),
};
export default {
    props: {
        isroute: {
            type: Boolean,
            default: false
        },
        // Floating Button icon Color        
        appointment: {
            type: Object,
            default: null
        },        
        selectedAppointment: {
            type: Object,
            default: null
        },
        avatar: {
            type: String,
            default: require('@/assets/images/avatars/004-bald.svg')
        },
        title: {
            type: String,
            default: 'Timothy Clarksons'
        },
        subTitle: {
            type: String,
            default: 'Vue Developer'
        },
        isFavorite: {
            type: Boolean,
            default: false
        },
        isVerified: {
            type: Boolean,
            default: false
        },
        ratingCount: {
            type: Number,
            default: 0
        },
        rating: {
            type: Number,
            default: 0
        },
        readmode: {
            type: Boolean,
            default: false
        },
        selectedTechnician: {
            type: Object,
            default: null
        }  
    },
    data() {
        return {
            selected: this.appointment.selected,
            help_rating: 4,
            favorite: this.isFavorite,  
            verified: this.isVerified,     
            markers: markerss,       
            //isroute: this.isroute,          
        }
    },
    computed: {
        focused() {
            return this.selectedAppointment != null && this.appointment.id == this.selectedAppointment.id;
        },
        isrouteDynamic() {
            try {
                let x = this.appointment.assignment;
                if(x && x.prelocked_manual) {
                    return true;
                }
                if(x && x.prelocked_tech && x.prelocked_time == true) {
                    return true;
                }
                return this.isroute;   
            } catch (error) {
                return true;
            }            
        }
    },
    methods: {
        selectedchanged({id, selected}) {
            this.$emit('selectedchanged', {id, selected});
        },
        edit(){
            this.$emit('edittime', this.appointment);
        }
    }
}
</script>
<style scoped lang="scss"> 

    .slotbutton {      
        font-size: 1.1em;  
        display: inline-block;
        background-color: #444; 
        text-align: center; 
        border-radius: 5px; 
        padding-bottom: 5px; 
        padding-top: 3px; 
        color:white; 
        font-weight: bold; 
        text-wrap: wrap; 
        overflow: hidden;                 
        margin-top: 4px; 
        padding-left: 4px; 
        padding-right: 7px;         
        word-break: break-all;
        min-width: 120px !important;
    }

    .slotbutton.prelocked_manual {        
        background-color: #61b8f4; 
    }

    .appt-card {
        border-radius: 5px 5px 0px 0px;
        background-color: #ff8f8f;
        div.v-input__control {
            margin-bottom: 2px !important;
        }  
        &:hover {
            background-color: #ff8f8f;
        }           
        
         margin-right: 4px;

         .theme--light.v-label {
            color: black;
         }
    }

    .appt-card.isroute {
        border-radius: 5px 5px 0px 0px;
        background-color: #ffd700;
        div.v-input__control {
            margin-bottom: 2px !important;
        }  
        &:hover {
            background-color: #ffd700;
        }           
        
         margin-right: 4px;

         .theme--light.v-label {
            color: black;
         }
    }

    .appt-card.focused {        
        background-color: #92ff5f !important;
    }

    .appt-card.selected {        
        background-color: #72d8ff !important;
    }

    .appt-card.focused.selected {        
        background-color: #6cccf2 !important;
    }

    .btnvertical {
        display: flex;
        flex-direction: column;
        align-items: center;

        span {
            font-size: 0.7em;
        }
    }
</style>

